import React from 'react';
import { useLocation } from '@reach/router';
import { Helmet } from 'react-helmet';

// Interfaces
import { Seo as SeoInterface } from '../../interfaces/seo';
interface SeoProps {
  seo: SeoInterface;
}

const Seo = (props: SeoProps) => {
  const { seo } = props;

  const title = seo.title ? seo.title : '';
  const locale = seo.locale ? seo.locale : 'en';
  const ogtitle = seo.ogtitle ? seo.ogtitle : '';
  const description = seo.description ? seo.description.description : '';
  const ogdescription = seo.ogdescription ? seo.ogdescription.ogdescription : '';
  const ogtype = seo.ogtype ? seo.ogtype : 'website';
  const image = seo.image ? seo.image.file.url : '';
  const author = seo.author ? seo.author : '';
  const keywords = seo.keywords ? seo.keywords.keywords : '';
  const robots = seo.robots ? seo.robots : '';
  const revisitAfter = seo.revisitAfter ? seo.revisitAfter : '';

  const location = useLocation();

  return (
    <Helmet
      htmlAttributes={{
        lang: locale,
      }}
      title={title}
      meta={[
        {
          property: 'og:title',
          content: ogtitle,
        },
        {
          name: 'description',
          content: description,
        },
        {
          property: 'og:description',
          content: ogdescription,
        },
        {
          property: 'lang',
          content: locale,
        },
        {
          property: 'og:locale',
          content: locale,
        },
        {
          name: 'author',
          content: author,
        },
        {
          property: 'og:image',
          content: image && 'https:' + image,
        },
        {
          property: 'og:image:url',
          name: 'image',
          content: image && 'https:' + image,
        },
        {
          name: 'keywords',
          content: keywords,
        },
        {
          name: 'robots',
          content: robots,
        },
        {
          name: 'revisit-after',
          content: revisitAfter,
        },
        {
          property: 'og:type',
          content: ogtype,
        },
        {
          name: 'twitter:card',
          content: 'summary_large_image',
        },
        {
          name: 'twitter:creator',
          content: author,
        },
        {
          name: 'twitter:title',
          content: title,
        },
        {
          name: 'twitter:description',
          content: description,
        },
        {
          name: 'twitter:url',
          content: typeof window !== 'undefined' ? location.href : '',
        },
        {
          name: 'twitter:image',
          content: image && 'https:' + image,
        },
      ]}
    >
      <link rel='canonical' href={typeof window !== 'undefined' ? location.href : ''} />

      <link rel='preconnect' href='https://fonts.googleapis.com' />
      <link rel='preconnect' href='https://fonts.gstatic.com' crossOrigin='true' />
      <link
        href='https://fonts.googleapis.com/css2?family=Rubik:wght@400;500;600&display=swap'
        rel='stylesheet'
      />
      {/* Hubspot tracking code */}
      <script
        type='text/javascript'
        id='hs-script-loader'
        async
        defer
        src='//js.hs-scripts.com/3942778.js'
      ></script>
    </Helmet>
  );
};

export default Seo;
